<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CWrapper>
      <TheHeader :user="user" />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid class="no-gap">
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </CWrapper>
    <CenterLoading />
    <DialogMessage />
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import CenterLoading from "@/projects/components/dialog/CenterLoading.vue";
import DialogMessage from "@/projects/components/dialog/DialogMessage.vue";

export default {
  name: 'TheContainer_Landing',
  components: {
    DialogMessage,
    CenterLoading,
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside
  },
  data() {
    return {
      user: null
    }
  },
  mounted() {
    const user = localStorage.getItem('user')
    if (user) {
      this.user = JSON.parse(user)
      console.log(123,this.user)
      this.$store.commit('auth/SET_USER', this.user)
      this.handleRoleRedirect(this.user)
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.no-gap {
  margin: 0 !important;
  padding: 0 !important;
}
.c-body {
  padding-top: 0 !important;
  margin-top: 0 !important;
}
.c-main {
  padding-top: 0 !important;
  margin-top: 0 !important;
}
</style>
